import React from 'react'
import { default as ReactNumberFormat } from 'react-number-format'

export const formatAsCurrency = (value) => {
  if (isNaN(value)) {
    throw (
      `Formatting error: Attempting to format value \`${value}\` as` +
      'currency, but the it is NaN.'
    )
  }
  return new Intl.NumberFormat('fi-FI', {
    style: 'currency',
    currency: 'EUR'
  }).format(value)
}

export const CurrencyInput = (props) => {
  const { inputRef, ...rest } = props
  return (
    <ReactNumberFormat
      {...rest}
      suffix=" €"
      decimalSeparator=","
      fixedDecimalScale={true}
      decimalScale={2}
      getInputRef={inputRef}
      isNumericString={true}
    />
  )
}

export const NumberInput = (props) => {
  const {
    onChange,
    inputRef,
    getInputRef,
    suffix = '',
    decimalScale,
    fixedDecimalScale = false,
    characterLimit,
    ...rest
  } = props

  return (
    <ReactNumberFormat
      {...rest}
      getInputRef={getInputRef ? getInputRef : inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value.replace(/,/g, '.')
          }
        })
      }}
      suffix={suffix}
      decimalSeparator=","
      isNumericString={true}
      fixedDecimalScale={fixedDecimalScale}
      decimalScale={decimalScale}
      isAllowed={(inputObj) => {
        const { value } = inputObj
        if (typeof characterLimit === 'undefined') {
          return true
        }
        if (value.toString().length <= characterLimit) {
          return true
        } else return false
      }}
    />
  )
}

export const GenericNumberInput = (props) => (
  <NumberInput {...props} decimalScale={2} />
)

export const NumberFormat = (props) => {
  const {
    value = 0,
    className,
    decimalScale = 2,
    displayType = 'text',
    suffix,
    prefix
  } = props

  return (
    <ReactNumberFormat
      value={value}
      className={className}
      decimalSeparator=","
      isNumericString={true}
      fixedDecimalScale={true}
      decimalScale={decimalScale}
      displayType={displayType}
      suffix={suffix}
      prefix={prefix}
    />
  )
}
